<template>
  <div class="register">
    <avl-box class="register__box" v-loading="isLoading">
      <h2 class="register__title">Register</h2>

      <form @submit.prevent="onSubmit" autocomplete="off">
        <div class="register__form-fields">
          <label for="username">Username</label>
          <el-input
            class="register__field"
            id="username"
            label="Username"
            v-model="username"
          ></el-input>

          <label for="email">Email</label>
          <el-input class="register__field" id="email" label="Email" v-model="email"></el-input>

          <label for="password">Password</label>
          <avl-password-input
            class="register__field"
            id="password"
            label="Password"
            v-model="password"
          ></avl-password-input>
        </div>

        <avl-recaptcha-wrapper
          ref="recaptchaWrapper"
          @verify="onVerify($event)"
        ></avl-recaptcha-wrapper>

        <div class="register__footer">
          <el-button class="register__button" native-type="submit" :disabled="buttonDisabled">
            Register
          </el-button>

          <router-link class="register__login-link" :to="{ name: 'userLogin' }">
            Log in
          </router-link>
        </div>
      </form>
    </avl-box>
  </div>
</template>

<script>
  import recaptchaMixin from '../../mixins/recaptcha';

  export default {
    mixins: [recaptchaMixin],
    data: () => ({
      email: '',
      username: '',
      password: '',
      isLoading: false,
    }),
    computed: {
      buttonDisabled() {
        return !(this.email && this.username && this.password && this.gRecaptchaToken);
      },
    },
    methods: {
      async onSubmit() {
        this.isLoading = true;

        const registerData = {
          username: this.username,
          email: this.email,
          password: this.password,
          gRecaptchaToken: this.gRecaptchaToken,
        };

        await this.$store.dispatch('auth/register', registerData);

        this.clearRecaptchaToken();
        this.$refs.recaptchaWrapper.reset();
        this.isLoading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .register {
    &__box {
      width: 300px;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__title {
      margin: 0 0 24px;
      text-align: center;
    }

    &__form-fields {
      margin-bottom: 24px;
    }

    &__field {
      margin-bottom: 12px;
    }

    &__footer {
      width: 100%;
      text-align: center;
    }

    &__button {
      margin-right: 12px;
    }

    &__login-link {
    }
  }
</style>
